<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.assignee') }}
          b-form-select(v-model="assignee" size="sm" @change="getCpiMemberCustomList(true)")
            option(value="") {{ $t('ui.all') }}
            option(v-for="info in subAccountList" :value="info.login_id") {{ info.login_id }}
      .form-group.col-md-9.col-10.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getCpiMemberCustomList(true)"
          variant="primary"
          size="sm"
        )
      .form-group.col-12
        jsonToExcel(v-if="cpiMemberList.length > 0" mode="CPICustomList" tbl="tblListCpiCustomList" :date="dateRange" btnTxt="export_one" type="1" :loading2="loading").mr-2
        cpiCustomListExport(v-if="cpiMemberList.length > 0" :tbl="cpiMemberList" tblId="tblListCpiCustomList")

  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)"
        )
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="9%")
                  span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                th(width="9%")
                  span(:title="$t('ui.name')") {{ $t("ui.name") }}
                th(width="9%")
                  span(:title="$t('ui.email')") {{ $t('ui.email') }}
                th.text-center(width="14%")
                  span(:title="$t('ui.assignee')") {{ $t("ui.assignee") }}
                th.text-center(width="8%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%")
                  span(:title="$t('ui.urgency')") {{ $t("ui.urgency") }}
                th(width="10%")
                  span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
                th(width="10%")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                th.text-right(width="10%")
                  span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
            tbody.clusterize-content
              tr(v-if="cpiMemberList.length == 0")
                td(:colspan="11").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in cpiMemberList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.phone") {{ item.phone }}
                td
                  span(:title="item.fullname") {{ item.fullname }}
                td
                  small.d-block(:title="item.email") {{ item.email }}
                  small.d-block(:title="item.email2") {{ item.email2 }}
                  small.d-block(:title="item.email3") {{ item.email3 }}
                td.text-center
                  template(v-if="isEditAccess && isAdmin")
                    b-form-select(v-model="item.login_id" @change="changedAssignee(item, $event)" size="sm" :disabled="loading")
                      option(v-for="info in subAccountList" :value="info.login_id") {{ info.login_id }}
                  template(v-else)
                    span(:title="item.login_id") {{ item.login_id }}
                td.text-center
                  span(:title="item.status") {{ item.status }}
                td.text-center
                  template(v-if="isEditAccess && isAdmin")
                    b-form-select.text-uppercase(v-model="item.urgency" @change="changedUrgency(item, $event)" size="sm" :disabled="loading")
                      option(:value="1") {{ $t("ui.urgency_1") }}
                      option(:value="2") {{ $t("ui.urgency_2") }}
                      option(:value="3") {{ $t("ui.urgency_3") }}
                  template(v-else)
                    span.text-uppercase(:title='$t("ui.urgency_" + item.urgency)' :class="getUrgencyBadgeClass(item.urgency)") {{ $t("ui.urgency_" + item.urgency) }}
                td
                  span(:title="item.remark") {{ item.remark }}
                td.text-right
                  template(v-if="item.created_on != null")
                    span.d-block(:title="item.created_by") {{ item.created_by }}
                    span.d-block(:title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
                td.text-right
                  template(v-if="item.modified_on != null")
                    span.d-block(:title="item.modified_by") {{ item.modified_by }}
                    span.d-block(:title="$moment(item.modified_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_on).format('YYYY-MM-DD, HH:mm:ss') }}
                  span(v-else) -
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import cpiCustomListExport from "@/components/cpi/cpiCustomListExportFull.vue";

export default {
  components: {
    SubmitButton,
    jsonToExcel,
    cpiCustomListExport
  },
  data: () => ({
    loading: false,
    cpiMemberList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "",
    sortType: "",
    assignee: '',
    subAccountList: [],
    dateRange: {
      startDate: null,
      endDate: null
    }
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeCpiCustomList;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_cpi");
    }
  },
  mounted: function() { },
  methods: {
    refresh() {
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      this.getSubAccountList();
    },
    getUrgencyBadgeClass(urgency) {
      var badgeClass = ''
      switch(urgency) {
        case 1:
          badgeClass = this.$helpers.badgeClass('LOW')
          break;
        case 2:
          badgeClass = this.$helpers.badgeClass('MODERATE')
          break;
        case 3:
          badgeClass = this.$helpers.badgeClass('HIGH')
          break;
      }
      return badgeClass
    },
    getCpiMemberCustomList: function(isSearch) {
      let url = config.cpiMemberCustomListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.operatorID,
        assignee: this.assignee,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiMemberList = response.data.dt;
                this.totalRow = this.cpiMemberList.length > 0 ? this.cpiMemberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getSubAccountList: function() {
      let url = config.accountSubListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: this.operatorID,
        page_number: 1,
        page_size: 100
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subAccountList = response.data.dt;
                this.getCpiMemberCustomList(true);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedAssignee: function(info, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_cpi_custom_assignee_confirm", { name: info.phone }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAssignee(info, eventStatus);
          } else {
            this.getCpiMemberCustomList()
          }
        });
    },
    confirmAssignee: function(info, assignee) {
      let url = config.cpiMemberCustomMoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.operatorID,
        phone: info.phone,
        target_account_id: assignee,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.assignee"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getCpiMemberCustomList()
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedUrgency: function(info, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_cpi_custom_urgency_confirm", { name: info.phone }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUrgency(info, eventStatus);
          } else {
            this.getCpiMemberCustomList()
          }
        });
    },
    confirmUrgency: function(info, urgency) {
      let url = config.cpiMemberCustomUrgencyUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.operatorID,
        phone: info.phone,
        urgency: urgency,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.urgency"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getCpiMemberCustomList()
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeCpiCustomList", pageSize);
      this.currentPage = 1;
      this.getCpiMemberCustomList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getCpiMemberCustomList();
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getCpiMemberCustomList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
